import React from "react";
import styles from './DocumentProcessor.module.css';

export default function TextInputPanel({ value, onChange, placeholder }) {
    return (
        <>
            <h3>Введите текст:</h3>
            <textarea
                className={styles.docTextarea}
                placeholder={placeholder}
                rows={10}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
        </>
    );
}
